module.exports = __webpack_public_path__ + "img/guangpan.b744cef3.png";